import { Injectable } from "../../helpers";
import { CashDrawerTransaction, CashDrawer } from "../../pms-api/models";

export class CashDrawerService extends Injectable {
  static get $inject() {
    return [
      "CashDrawerPmsApiService",
      "CashDrawerTransactionPmsApiService",
      "$uibModal",
      "$rootScope",
      "$translate",
      "toastr",
      "CashDrawerErrorHandlerService",
    ];
  }

  setModel(model) {
    this.model = model;
  }

  addTransaction(
    property,
    amount,
    notes = null,
    reservationId = null,
    houseAccountId = null,
    expenses_item_id = null,
    apply_vat = null,
    paid_to = null
  ) {
    this.model = new CashDrawerTransaction({
      amount: amount,
      notes: notes,
      reservation_id: reservationId,
      house_account_id: houseAccountId,
      expenses_item_id: expenses_item_id,
      apply_vat: apply_vat,
      paid_to: paid_to,
    });

    this.property = property;

    if (
      this.$rootScope.$user.isMabeetStaff() ||
      this.$rootScope.$user.isAdminRole()
    ) {
      this.openCashDrawerModal();
    } else if (
      (!this.$rootScope.$user.isMabeetStaff() &&
        !this.$rootScope.$user.isAdminRole() &&
        (this.$rootScope.$user.canInProperty(
          this.property.id,
          "view open drawers and post transactions"
        ) ||
          this.$rootScope.$user.canInProperty(
            this.property.id,
            "open/close cash drawers"
          ))) ||
      this.$rootScope.can("create/modify drawers")
    ) {
      const index = this.$rootScope.$user.open_cash_drawers.findIndex(
        (cd) => cd.property_id === property.id
      );

      if (
        index !== -1 &&
        (!this.$rootScope.$user.canInProperty(
          this.property.id,
          "view open drawers and post transactions"
        ) ||
          this.$rootScope.open_cash_drawers.length === 1)
      ) {
        this.model.cash_drawer = this.$rootScope.$user.open_cash_drawers[index];

        this.save();
      } else {
        this.openCashDrawerModal();
      }
    } else {
      this.$rootScope.$emit("cash-drawer-transaction-saved");
    }
  }

  openCashDrawerModal() {
    this.CashDrawerPmsApiService.get(
      { "conditions[0]": CashDrawer.CONDITION_OPENED },
      this.property
    ).then((paginationCollection) => {
      if (
        !paginationCollection.models.length &&
        (this.$rootScope.$user.isAdminRole() ||
          !this.$rootScope.$user.canInProperty(
            this.property.id,
            "open/close cash drawers"
          ))
      ) {
        this.$rootScope.$emit("cash-drawer-transaction-saved");
      } else {
        this.$uibModal
          .open({
            component: "cashDrawerTransactionModal",
            size: "lg",
            resolve: {
              property: () => {
                return this.property;
              },
              transaction: () => {
                return this.model;
              },
              cashDrawers: () => {
                return paginationCollection.models;
              },
            },
          })
          .result.then((model) => {
            this.model.cash_drawer = model;

            this.save();
          });
      }
    });
  }

  save() {
    return this.CashDrawerTransactionPmsApiService.save(
      this.model,
      this.model.cash_drawer
    )
      .then((model) => {
        this.toastr.success(
          this.$translate.instant("YOUR_CHANGES_HAVE_BEEN_SAVED"),
          this.$translate.instant("SUCCESS")
        );

        this.$rootScope.$emit("cash-drawer-transaction-saved", model);
      })
      .catch((response) => {
        // Use centralized error handler
        if (!this.CashDrawerErrorHandlerService.handleError(response)) {
          // If not a handled cash drawer error, re-throw
          return Promise.reject(response);
        }
      });
  }

  onCashDrawerTransactionSaved(component) {
    return (event, cashDrawerTransactionModel) => {
      if (cashDrawerTransactionModel && component.submitModel) {
        component.submitModel.cash_drawer_transaction_id =
          cashDrawerTransactionModel.id;
        component.submitModel.cash_drawer_id =
          cashDrawerTransactionModel.cash_drawer.id;
      }

      component.saveTransaction();
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cash-drawer.service.js